import { getAcessToken } from '@/modules/shared/storage';
export default () => {
  return !!getAcessToken();
};
